<div class="min-h-screen bg-gray-50">
  <!-- Header -->
  <app-header [cartCount]="cartCount"></app-header>

  <!-- Page Content -->
  <section class="max-w-5xl mx-auto px-4 py-10">
    <div class="bg-white rounded-2xl shadow-sm p-6 md:p-10">

      <h1 class="text-2xl md:text-3xl font-semibold text-gray-800 mb-6">
        Delivery Policy
      </h1>

      <p class="text-sm text-gray-600 mb-8 leading-relaxed">
        At <span class="font-medium text-gray-800">capitalfood.in</span>, we are committed to delivering
        high-quality food with efficiency, transparency, and reliability.
        Please read our delivery policy carefully to understand how our services work.
      </p>

      <!-- Policy Sections -->
      <div class="space-y-8 text-sm text-gray-700 leading-relaxed">

        <div>
          <h2 class="font-semibold text-gray-800 mb-2">1. Delivery Partners</h2>
          <p>
            capitalfood.in operates as a direct partner with Swiggy and Zomato.
            All standard food deliveries placed through our platform are fulfilled
            via these third-party delivery partners. Delivery timelines, rider
            availability, and real-time tracking are managed by the respective platforms.
          </p>
        </div>

        <div>
          <h2 class="font-semibold text-gray-800 mb-2">2. Delivery Timings & Availability</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>Operational Days: Monday to Saturday</li>
            <li>Operational Hours: 11:00 AM to 06:00 PM</li>
            <li>
              Orders placed outside business hours or on Sundays will be processed
              on the next working day.
            </li>
          </ul>
        </div>

        <div>
          <h2 class="font-semibold text-gray-800 mb-2">3. Service Areas</h2>
          <p>Delivery availability is subject to:</p>
          <ul class="list-disc pl-5 space-y-1 mt-1">
            <li>Serviceable locations supported by Swiggy and Zomato</li>
            <li>Distance from our kitchen locations</li>
            <li>Local operational restrictions</li>
          </ul>
          <p class="mt-1">
            Delivery availability may vary by cuisine and location.
          </p>
        </div>

        <div>
          <h2 class="font-semibold text-gray-800 mb-2">4. Bulk & Corporate Orders</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>Bulk and corporate orders must be placed in advance</li>
            <li>Delivery timelines may differ from regular orders</li>
            <li>Special packaging and logistics may apply</li>
          </ul>
          <p class="mt-1">
            Our team will coordinate separately regarding preparation time
            and delivery schedules for bulk orders.
          </p>
        </div>

        <div>
          <h2 class="font-semibold text-gray-800 mb-2">5. Order Processing & Confirmation</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>Orders are prepared only after successful confirmation</li>
            <li>Confirmed orders cannot be cancelled or modified</li>
            <li>
              capitalfood.in reserves the right to cancel orders due to
              unforeseen circumstances such as stock unavailability,
              technical issues, or operational constraints
            </li>
          </ul>
        </div>

        <div>
          <h2 class="font-semibold text-gray-800 mb-2">6. Delivery Delays</h2>
          <p>Delays may occur due to:</p>
          <ul class="list-disc pl-5 space-y-1 mt-1">
            <li>Traffic conditions</li>
            <li>Weather issues</li>
            <li>High order demand</li>
            <li>Delivery partner constraints</li>
          </ul>
          <p class="mt-1">
            capitalfood.in is not responsible for delays caused by third-party
            delivery partners, but we will assist wherever possible.
          </p>
        </div>

        <div>
          <h2 class="font-semibold text-gray-800 mb-2">7. Cuisine Availability</h2>
          <p>
            We offer multiple cuisines across our platform. Availability of
            specific cuisines or menu items may vary based on time of order,
            ingredient availability, and kitchen capacity.
          </p>
        </div>

        <div>
          <h2 class="font-semibold text-gray-800 mb-2">8. Food Quality & Responsibility</h2>
          <ul class="list-disc pl-5 space-y-1">
            <li>All food is prepared following strict hygiene standards</li>
            <li>Customers are advised to consume food immediately upon delivery</li>
            <li>
              capitalfood.in is not responsible for quality issues arising
              from delayed consumption or improper handling after delivery
            </li>
          </ul>
        </div>

        <div>
          <h2 class="font-semibold text-gray-800 mb-2">9. Use of Cookies & Data</h2>
          <p>
            Our website uses cookies to enhance user experience, manage order flow,
            and store essential preferences. By using capitalfood.in, you consent
            to our use of cookies as outlined in our Privacy Policy.
          </p>
        </div>

        <div>
          <h2 class="font-semibold text-gray-800 mb-2">10. Customer Support</h2>
          <p>
            For any delivery-related concerns, including missing items or quality issues,
            please contact us within a reasonable time after delivery along with your
            order details for quick resolution.
          </p>
        </div>

        <div>
          <h2 class="font-semibold text-gray-800 mb-2">11. Policy Updates</h2>
          <p>
            capitalfood.in reserves the right to modify or update this Delivery Policy
            at any time without prior notice. Changes will be effective immediately
            upon posting on the website.
          </p>
        </div>

      </div>
    </div>
  </section>

  <!-- Footer -->
  <app-footer></app-footer>
</div>
